export const SET_ISSUE_UI_FLAG = 'SET_ISSUE_UI_FLAG';
export const CLEAR_ISSUES = 'CLEAR_ISSUES';
export const SET_ISSUES = 'SET_ISSUES';
export const SET_ISSUE_ITEM = 'SET_ISSUE_ITEM';
export const EDIT_ISSUE = 'EDIT_ISSUE';
export const DELETE_ISSUE = 'DELETE_ISSUE';
export const ADD_AGENTS_TO_ISSUE = 'ADD_AGENTS_TO_ISSUE';
export const UPDATE_ISSUES_PRESENCE = 'UPDATE_ISSUES_PRESENCE';
